import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=285e2bda&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=285e2bda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285e2bda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('285e2bda')) {
      api.createRecord('285e2bda', component.options)
    } else {
      api.reload('285e2bda', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=285e2bda&scoped=true&", function () {
      api.rerender('285e2bda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2uyKcTYWaE8rg/JS/comp/DocBox.vue"
export default component.exports